import { NavLink } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { getEquipmentAlertsDiagnosisByQuery } from "components/axios/equipmentAlertsAxios";
import MainCard from "components/MainCard";
import { Box, Chip, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import PageInfo from "components/PageInfo";
import { useEnumApi } from "contexts/EnumApiContext";
import CommonExcelDownload from "components/CommonExcelDownload";

const EquipmentAlertListCard = ({equipmentId, equipmentNo, setIsLoading : parentSetIsLoading}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    let [pageInfo, setPageInfo] = useState({});
    let [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    
    const excelTitle = t('menu.cmms.equipment-alert-history-tracking');
    const excelHeaders = [t('message.common.subtitle.status'),t('message.common.subtitle.dateAt'),t('message.common.subtitle.alertType'),t('message.common.subtitle.alertCategory'),t('message.common.subtitle.description')];
    const fileName = excelTitle+"_"+Date.now();
    const [excelDatas, setExcelDatas] = useState([]);

    const handlePaging = (value) => {
        value = isNaN(value) ? 1 : value;
        setCurrentPage(value-1);
        setIsLoading(false);
    }

    const [equipmentAlerts, setEquipmentAlerts] = useState();
    
    useEffect(()=>{
        if (equipmentId) {
            getEquipmentAlertList(equipmentId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPage, equipmentId]);

    const getEquipmentAlertList = (equipmentId) => {
        if (equipmentId) {
            isNaN(currentPage) && setCurrentPage(0);
            isNaN(pageSize) && setPageSize(10);

            let param = {
                sort : "latestAlertedAt,desc",
                page : currentPage,
                size : pageSize,
                "equipment.id" : equipmentId
            };

            getEquipmentAlertsDiagnosisByQuery(param).then((data)=>{
                if (data !== null) {
                    if(data.page) {
                        setPageInfo(data.page);
                    } else {
                        setCurrentPage(0);
                        pageInfo = {
                            size : pageInfo.size,
                            totalElements : 0,
                            totalPages : 0,
                            number : 0
                        }
                        setPageInfo(pageInfo);
                    }
                    
                    if (data && data._embedded) {
                        setEquipmentAlerts(data._embedded.equipmentAlerts);
                        return data.page.totalElements;
                    } else {
                        setEquipmentAlerts([]);
                        return 0;
                    }
                }
                
            }).then((res)=>{
                const totalCount = res;
                delete param.page;
                param.page = 0;
                delete param.size;
                param.size = totalCount;
                getEquipmentAlertsDiagnosisByQuery(param).then((data)=>{
                    if (data !== null) {
                        if (data && data._embedded) {
                            let excelDatas = [];
                            let excelData = [];
                            data._embedded.equipmentAlerts && data._embedded.equipmentAlerts.forEach(function(column) {
                                let alertDtl = (column.alertDtl || '');
                                // if (column.alertType === 'IOT' && alertDtl.indexOf(t('message.common.text.iot.diagnosis')) !== -1) {
                                    if (column.equipmentPartFaultCodes && column.equipmentPartFaultCodes.length > 0) {
                                        alertDtl += (alertDtl && "\n");
                                        column.equipmentPartFaultCodes.map(function(codes, idx) {
											alertDtl += codes.equipmentPart?.masterEquipmentPart?.name+'['+codes.equipmentPart?.position+']-';
											alertDtl += codes.diagnosisCode?.subCategoryNm+'('+codes.diagnosisCode?.categoryNm+')\n';
                                        })
                                    }
                                // }
                                excelData = [
                                    (column.status && column.status == 'D' ? (getEnumValueByEnumNameAndCode("EquipmentAlertStatus", column.status) && getEnumValueByEnumNameAndCode("EquipmentAlertStatus", column.status)[0].title)
                                        : column.status == 'M' && column.fllwActionType ? (getEnumValueByEnumNameAndCode("FollowActionType", column.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", column.fllwActionType)[0].title): ''),
                                    ((column.latestAlertedAt && dayjs(column.latestAlertedAt).format("YYYY-MM-DD HH:mm")) || ''),
                                    ((column.alertType && getEnumValueByEnumNameAndCode("AlertType", column.alertType) && getEnumValueByEnumNameAndCode("AlertType", column.alertType)[0].title) || ''),
                                    ((column.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", column.aleralertCategorytType) && getEnumValueByEnumNameAndCode("AlertCategory", column.alertCategory)[0].title) || ''),
                                    ((alertDtl) || '')
                                ];
                                excelDatas.push(excelData);
                            })
                            setExcelDatas(excelDatas);
                        } else {
                            setExcelDatas([]);
                        }
                    }
                    setIsLoading(true);
                })
            })
        } else {
            setEquipmentAlerts([]);
            setExcelDatas([]);
        }
    }

    if (isLoading) {
        return (
            <div className='alert_phrase' style={{marginTop: "20px"}}>
                <MainCard className="center_table" content={false}>
                    <div className='more' style={{paddingBottom: "10px"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                            <Chip label={t('menu.cmms.equipment-alert-history-tracking')} />
                        </div>
                        
                        <div style={{display:"flex",alignItems:"center"}}>
                            {(excelDatas && excelDatas.length > 0) ?
                            <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelHeaders} title={t('menu.cmms.report-dataroom.status-report.equipment-status')} filename={`${fileName}.xlsx`} />
                            :
                            ((equipmentAlerts && equipmentAlerts.length > 0) ?
                            <Box sx={{ display: 'flex', color:"#FFF" }}>
                                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                            </Box>
                            :'')
                            }
                            
                            &nbsp;&nbsp;<NavLink href={`/equipment-alert-history-tracking?searchField=equipmentNo&searchKeyword=${equipmentNo}`} className='more_btn'>{t('message.common.btn.more')} +</NavLink>
                        </div>
                    </div>
                    <TableContainer>
                    <Table sx={{ minWidth: 500 }} aria-label="simple table" className="base_link">
                        <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{width:"90px"}}>{t('message.common.subtitle.status')}</TableCell>
                            <TableCell style={{width:"150px"}}>{t('message.common.subtitle.dateAt')}</TableCell>
                            <TableCell align="center" style={{width:"60px"}}>{t('message.common.subtitle.alertType')}</TableCell>
                            <TableCell align="center" style={{width:"100px"}}>{t('message.common.subtitle.alertCategory')}</TableCell>
                            <TableCell align="center">{t('message.common.subtitle.description')}</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {equipmentAlerts && equipmentAlerts.map((alert, i) => {
                            let linkUrl = "/equipment-alert-history-tracking/"+alert.id+"?searchField=equipmentNo&searchKeyword="+equipmentNo;
                            let statusClassName = '';
                            if (alert.status) {
                                if (alert.status === 'D' || alert.status === 'F') {
                                    statusClassName = 'condition1';
                                } else if (alert.status === 'M') {
                                    if (alert.fllwActionType) {
                                        if (alert.fllwActionType === 'O1_WAIT')
                                            statusClassName = 'condition1';
                                        else if (alert.fllwActionType === 'O2_OBSERVE')
                                            statusClassName = 'condition3';
                                        else if (alert.fllwActionType === 'O3_MNT')
                                            statusClassName = 'condition5';
                                        else if (alert.fllwActionType === 'O4_NORMAL')
                                            statusClassName = 'condition6';
                                    }
                                }
                            }

                            let alertDtl = (alert.alertDtl || '');
                            // if (alert.alertType === 'IOT' && alertDtl.indexOf(t('message.common.text.iot.diagnosis')) !== -1) {
                            if (alert.equipmentPartFaultCodes && alert.equipmentPartFaultCodes.length > 0) {
                                alertDtl += (alertDtl && "<br/>");
                                alert.equipmentPartFaultCodes.map(function(codes, idx) {
                                    alertDtl += codes.equipmentPart?.masterEquipmentPart?.name+'['+codes.equipmentPart?.position+']-';
                                    alertDtl += codes.diagnosisCode?.subCategoryNm+'('+codes.diagnosisCode?.categoryNm+')<br />';
                                })
                            }
                        // }
                            return (
                            <TableRow hover key={i} style={{verticalAlign:"top"}}>
                                <TableCell component="th" scope="row" className={statusClassName}><NavLink href={linkUrl}>
                                    {(alert.status && alert.status === 'D' || alert.status && alert.status === 'F') && getEnumValueByEnumNameAndCode("EquipmentAlertStatus", alert.status) && getEnumValueByEnumNameAndCode("EquipmentAlertStatus", alert.status)[0].title}
                                    {alert.status && alert.status === 'M' && alert.fllwActionType &&
                                    getEnumValueByEnumNameAndCode("FollowActionType", alert.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", alert.fllwActionType)[0].title}
                                </NavLink></TableCell>
                                <TableCell align="center"><NavLink href={linkUrl}>{alert.latestAlertedAt && dayjs(alert.latestAlertedAt).format("YYYY-MM-DD HH:mm")}</NavLink></TableCell>
                                <TableCell align="center"><NavLink href={linkUrl}>{alert.alertType && getEnumValueByEnumNameAndCode("AlertType", alert.alertType) && getEnumValueByEnumNameAndCode("AlertType", alert.alertType)[0].title}</NavLink></TableCell>
                                <TableCell align="center"><NavLink href={linkUrl}>{alert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory) && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory)[0].title}</NavLink></TableCell>
                                <TableCell style={{whiteSpace:"pre-line",textAlign:"left"}}><NavLink href={linkUrl} dangerouslySetInnerHTML={ {__html: alertDtl } }></NavLink></TableCell>
                            </TableRow>
                        )
                        })}
                        </TableBody>
                    </Table>
                    </TableContainer>
                    <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
                </MainCard>
            </div>
        )
    }
}

export default EquipmentAlertListCard;